module.exports = __webpack_public_path__ + "static/media/ic_template_3.98c8b5fd.png";